import { writable, derived } from 'svelte/store';
import api from '../services/api.js';

function createAuthStore() {
  const { subscribe, set, update } = writable({
    user: null,
    loading: true,
    error: null,
  });

  return {
    subscribe,
    
    async init() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        set({ user: null, loading: false, error: null });
        return;
      }

      try {
        const user = await api.getCurrentUser();
        set({ user, loading: false, error: null });
      } catch (error) {
        api.clearToken();
        set({ user: null, loading: false, error: error.message });
      }
    },

    setToken(token) {
      api.setToken(token);
      this.init();
    },

    async logout() {
      try {
        await api.logout();
      } catch (e) {
        // Ignore logout errors
      }
      api.clearToken();
      set({ user: null, loading: false, error: null });
      // Force navigation to login page
      window.location.href = '/auth/login';
    },

    clearError() {
      update(state => ({ ...state, error: null }));
    },
  };
}

export const auth = createAuthStore();

export const isAuthenticated = derived(
  auth,
  $auth => $auth.user !== null && !$auth.loading
);

export const isLoading = derived(
  auth,
  $auth => $auth.loading
);

export const user = derived(
  auth,
  $auth => $auth.user
);

export const hasAlpacaAccount = derived(
  auth,
  $auth => $auth.user?.alpaca_connected === true
);